import CritiqueReviewMainBanner from './CritiqueReviewMainBanner'
export default CritiqueReviewMainBanner
